import ZiniHubCustPrototype from "./ZiniHubCustPrototype";

export default ZiniHubCustPrototype;
